import Cookies from 'js-cookie';
(async () => {

  /* Update cart items */
  if (!customElements.get('cart-items')) {
    const { Fancybox } = await import('@fancyapps/ui');
    class CartItems extends HTMLElement {
      constructor() {
        super();

        this.activeFunnels = [];
        this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
        this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
          (total, quantityInput) => total + parseInt(quantityInput.value),
          0
        );

        this.promoWrapper = document.querySelector('[data-promo-remove-wrapper]');

        this.debouncedOnChange = debounce((event) => {
          if (event.target != document.querySelector('[data-upgrade-order-trigger]')) {
            if (event.target != document.getElementById('Cart-note')) {
              if (typeof event.target.dataset.subscriptionSelect !== 'undefined') {
                this.onSubscriptionChange(event);
              } else {
                this.onChange(event);
              }
            }
          }
        }, 300);

        this.addEventListener('change', this.debouncedOnChange.bind(this));
        this.handleSubscriptions();

        if (this.querySelector('[data-funnel-trigger]')) {
          this.querySelector('[data-funnel-trigger]').addEventListener('click', () => {
            this.activeFunnels = [];
            if (window.funnel_data && window.funnel_data.popup_2) {

              let variant_ids = window.funnel_data.variant_ids.split(',');


              variant_ids.forEach((variantID) => {
                this.collectFunnels(variantID);
              });

              this.handleFunnel();
            } else {
              this.triggerOcu();
            }
          });
        }
      }

      collectFunnels(id) {
        let funnelArr = window.funnel_data.funnels;
        this.activeFunnelId = '';
        funnelArr.forEach((funnel) => {
          if (funnel.destination == 'popup2') {
            funnel.triggerVariantIds.forEach((variantId) => {
              let variant_id = variantId.split('ProductVariant/')[1];
              if (variant_id == id) {
                this.activeFunnels.push(funnel);
                this.activeFunnelId = id;
              }
            })
          }
        })
      }

      handleFunnel() {
        console.log('this.activeFunnels', this.activeFunnels);
        let default_funnel = window.funnel_data.default_funnel;
        let preffered_funnel = window.funnel_data.preffered_funnel;
        let active_funnel = false;

        if (this.activeFunnels.length > 0) {
          active_funnel = true;
        }

        if (active_funnel) {
          this.singular_funnel = '';
          // find preffered funnel
          this.activeFunnels.forEach((funnel1) => {
            if (funnel1.funnelType == preffered_funnel) {
              this.singular_funnel = funnel1;
            }
          });

          if (this.singular_funnel == '') {
            // find default funnel
            this.activeFunnels.forEach((funnel1) => {
              if (funnel1.funnelType == default_funnel) {
                this.singular_funnel = funnel1;
              }
            });
          }

          if (this.singular_funnel == '') {
            this.handleDefaultATC();
          } else {
            let destination = this.singular_funnel.destination;
            let funnelType = this.singular_funnel.funnelType;
            let popupParent = document.querySelector('[data-popup-destination="' + destination + '"]');
            if (popupParent && popupParent.querySelector('[data-popup-type="' + funnelType + '"]')) {
              let popupWrapper = popupParent.querySelector('[data-popup-type="' + funnelType + '"]');
              this.handleData(popupWrapper);
            }
          }

        } else {
          this.handleDefaultATC();
        }
      }

      /*
        Handle data
      */
      handleData(popupWrapper) {

        console.log('I handle Data');
      
        // find funnel meta
        this.funnel_metadata = '';
        let funnel_id = this.singular_funnel.id;
        window.funnel_data.funnels_meta.forEach((funnel_meta) => {
          if (funnel_meta.funnel_id == funnel_id) {
            this.funnel_metadata = funnel_meta;
            console.log('found funnel_metadata', this.funnel_metadata);
          } 
        });

        if (this.funnel_metadata !== '') {
          // update discount
          let discount = this.singular_funnel.settings.variantA.discount;
          popupWrapper.querySelectorAll('[data-funnel-discount]').forEach((discountHtml) => {
            discountHtml.innerHTML = discount;
          });

          // update title
          let upgradeProduct = this.funnel_metadata.upgrade_product.title;
          popupWrapper.querySelectorAll('[data-funnel-upgrade-title]').forEach((element) => {
            element.innerHTML = upgradeProduct;
          });

          // update image
          let updateImage = this.funnel_metadata.upgrade_product.upgrade_image;
          popupWrapper.querySelector('[data-funnel-upgrade-image]').src = updateImage;

          // old products
          this.funnel_metadata.trigger_products.forEach((trigger_product, index) => {
            if (index == 0) {
              popupWrapper.querySelectorAll('[data-old-products-title]').forEach((element) => {
                element.innerHTML = trigger_product.title;
              });
            } else {
              popupWrapper.querySelectorAll('[data-old-products-title]').forEach((element) => {
                element.innerHTML = element.innerHTML + ', ' + trigger_product.title;
              });
            }
          });

          // prices
          let oldPrice = this.funnel_metadata.triggers_price;
          let savings = oldPrice / 100 * discount;
          let newPrice = oldPrice - savings;

          if (this.singular_funnel.funnelType == 'replace') {
            oldPrice = this.funnel_metadata.upgrade_product.compare_at_price;
            newPrice = this.funnel_metadata.upgrade_product.price;
            savings = oldPrice - newPrice;
          }

          popupWrapper.querySelector('[data-funnel-old-price]').innerHTML = oldPrice / 100;
          popupWrapper.querySelector('[data-funnel-new-price]').innerHTML = newPrice / 100;
          popupWrapper.querySelector('[data-funnel-save-price]').innerHTML = savings / 100;

          // variant selector
          if (this.singular_funnel.funnelType == 'replace') {

            let url = 'https://www.primeprometics.com/products/complete-makeover-bundle';
            fetch(url)
              .then((response) => response.text())
              .then((responseText) => {
                const html = responseText;
                let element = new DOMParser().parseFromString(html, 'text/html').querySelector('combined-bundle').innerHTML;
                popupWrapper.querySelector('[data-funnel-option-select]').innerHTML = element;
                popupWrapper.querySelector('[data-bundle-purchaser]').remove();
                this.handlePopup(popupWrapper);
              });

          } else {

            let select = popupWrapper.querySelector('[data-funnel-selected-id]');
            let option = '';
            this.funnel_metadata.upsell_variants.forEach((variant) => {
              let variantArr = variant.split('||');
              option = document.createElement("option");
              option.text = variantArr[1].replace('++', '+');
              option.value = variantArr[0].replace('::', ',');
              select.appendChild(option);
            });
            this.handlePopup(popupWrapper);
          }

        } else {
          this.handlePopup(popupWrapper);
        }

      }

      /*
        Handle popup
      */
      handlePopup(popupWrapper) {

        // adjust data
        new Fancybox(
          [
            {
              src: popupWrapper.innerHTML,
              type: "html",
            },
          ],
          {
            on: {
              done: (fancybox, slide) => {
                let accept = slide.$content.querySelector('[data-funnel-accept]');
                let decline = slide.$content.querySelector('[data-funnel-decline]');
                slide.$content.querySelectorAll('[data-bundle-variant]').forEach((variant) => {
                  variant.addEventListener('click', (e) => {
                    e.target.closest('[data-bundle-variant-group]').querySelector('.border-black').classList.remove('border-black');
                    if (e.target.src) {
                      e.target.closest('[data-bundle-variant]').classList.add('border-black');
                    } else {
                      e.target.classList.add('border-black');
                    }
                    let img = e.target.closest('[data-bundle-variant-group]').querySelector('.border-black img').src;
                    let color = e.target.closest('[data-bundle-variant-group]').querySelector('[data-bundle-variant].border-black').dataset.bundleVariantColor;
                    e.target.closest('[data-total-bundle]').querySelector('[data-current-bundle-variant] span').innerHTML = color;
                    e.target.closest('[data-total-bundle]').querySelector('[data-current-bundle-variant] img').src = img;
                    e.target.closest('[data-total-bundle]').querySelector('[data-current-bundle-variant] img').srcset = img;
                  });
                });
                // decline -- close
                decline.addEventListener('click', (event) => {
                  fancybox.close();
                  this.handleDefaultATC();
                });
                // accept offer
                accept.addEventListener('click', (event) => {
                  let ids = [];

                  if (this.singular_funnel.funnelType == 'replace') {
                    ids = [];
                    slide.$content.querySelector('[data-funnel-option-select]').querySelectorAll('[data-bundle-variant-group]').forEach((variant) => {
                      ids.push(variant.querySelector('.border-black').dataset.bundleVariantId);
                    });
                  } else {
                    let option = slide.$content.querySelector('[data-funnel-selected-id]');
                    ids = option.querySelector('option:checked').value.split(',');
                  }
                  
                  this.items = [];
                  let object = {};
                  if (ids.length > 0) {
                    ids.forEach((id) => {
                      let properties = {};
                      properties._promo_product = 'false';
                      properties._funnel = 'cart';
                      properties._funnel_location = 'popup2';
                      properties._funel_type = 'automatically added';
                      properties._promo = false;
                      properties._promo_discount = this.singular_funnel.settings.variantA.discount;
                      properties._promo_discount_type = 'percentage';
                      properties.product_bundle = this.funnel_metadata.upgrade_product.title;
                      properties._product_bundle_discount = this.singular_funnel.settings.variantA.discount;
                      properties._product_bundle_image = this.funnel_metadata.upgrade_product.upgrade_image;
                      properties._product_bundle_name = this.funnel_metadata.upgrade_product.title;
                      properties._product_bundle_variant_id = this.funnel_metadata.upgrade_product.variant_id;
                      object = {};
                      object = {
                        quantity: 1,
                        id: parseInt(id),
                        properties
                      }
                      this.items.push(object);
                    });
        

                    console.log('check this.activeFunnelId', this.activeFunnelId);

                    let body = JSON.stringify({
                      id: this.activeFunnelId,
                      quantity: 0,
                      sections: this.getSectionsToRender().map((section) => section.id),
                      sections_url: window.location.pathname
                    });
                    
                    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
                      .then((response) => response.json())
                      .then((parsedState) => {
                        console.log('worked fine', parsedState);
                        addProduct(this.items);
                      })
                      .catch((e) => {
                        console.error(e);
                      })
                    

                    function addProduct(items) {

                      body = JSON.stringify({
                        items: items
                      });

                      fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
                        .then((response) => response.json())
                        .then((parsedState) => {
                          location.href = location.origin + '/checkout';
                        })
                        .catch((e) => {
                          console.error(e);
                        })
                    }


                  }
                });
              },
              shouldClose: (fancybox, eventName) => {
                // decline offer
                if (typeof eventName !== 'undefined') {
                  if (eventName.target) {
                    this.handleDefaultATC();
                  }
                }
              }
            },
            mainClass: 'funnel-popup'
          }
        );
      }

      triggerOcu() {
        this.querySelector('[data-checkout-button]').click();
      }

      handleDefaultATC() {
        console.log('close it')
        location.href = location.origin + '/checkout';
      }

      onChange(event) {
        this.updateQuantity(
          event.target.dataset.index,
          event.target.value,
          document.activeElement.getAttribute('name')
        );
      }

      onSubscriptionChange(event) {
        this.upgradeSubscription(event);
      }

      getSectionsToRender() {
        return [
          {
            id: 'main-cart-header',
            section: document.getElementById('main-cart-header').dataset.id,
            selector: '.js-cart-header-contents',
          },
          {
            id: 'main-cart-items',
            section: document.getElementById('main-cart-items').dataset.id,
            selector: '.js-cart-item-contents',
          },
          {
            id: 'main-cart-related',
            section: document.getElementById('main-cart-related').dataset.id,
            selector: '.js-cart-related-contents',
          },
          {
            id: 'main-cart-samples',
            section: document.getElementById('main-cart-samples').dataset.id,
            selector: '.js-cart-samples-contents',
          },
          {
            id: 'main-cart-footer',
            section: document.getElementById('main-cart-footer').dataset.id,
            selector: '.js-cart-footer-contents',
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '[data-cart-icon-bubble]',
          },
          {
            id: 'product-promos',
            section: document.getElementById('product-promos').dataset.id,
            selector: '[data-product-promos-replace]',
          },
        ];
      }

      updateQuantity(line, quantity, name) {
        this.enableLoading(line);

        const body = JSON.stringify({
          line,
          quantity,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);

            this.classList.toggle('cart-is-empty', parsedState.item_count === 0);

            if (parsedState.item_count === 0) {
              Cookies.remove('refused_promos')
            }

            this.getSectionsToRender().forEach((section) => {
              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) ||
                document.getElementById(section.id);
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );

              // Re-bind the close cart drawer buttons if cart drawer exists
              const cartDrawer = document.querySelector('cart-drawer');
              if (section.id === 'main-cart-header' && cartDrawer) {
                cartDrawer
                  .querySelectorAll('[data-cart-button-close]')
                  .forEach((btn) => btn.addEventListener('click', cartDrawer.close.bind(cartDrawer)));
              }
            });

            this.updateLiveRegions(line, parsedState.item_count);
            document.getElementById(`CartItem-${line}`)?.querySelector(`[name="${name}"]`)?.focus();

            this.handleDiscounts();
            this.handleSubscriptions();
            this.handleProgressBar();
            this.handleOrderUpgrade(parsedState);
            this.disableLoading();

            if (location.href == location.origin + '/cart' && parsedState.item_count == 0) {
              location.reload();
            }

            if (document.querySelector('cross-sell')) {
              document.querySelector('cross-sell').guardRemovals();
            }

            document.querySelectorAll('[data-max-width]').forEach((element) => {
              let maxWidth = element.dataset.maxWidth;
              element.style.maxWidth = maxWidth + '%';
            })
            
          })
          .catch((error) => {
            console.log('error 1', error);
            document.querySelector('[data-cart-loader-active="show"]')?.classList.add('hidden');
            document.querySelector('[data-cart-loader-active="hidden"]')?.classList.remove('hidden');
            document.getElementById('cart-errors').textContent = window.cartStrings.error;
            this.disableLoading();
          });
      }

      handleOrderUpgrade(parsedState) {
        if (this.querySelector('[data-order-upgrade]')) {

          let data = this.querySelector('[data-order-upgrade]').dataset;
          let giftCard = parseInt(data.orderUpgradeGift);
          let insurance = parseInt(data.orderUpgradeInsurance);
          let removeUpgrade = true;
          parsedState.items.forEach((item) => {
            if (item.id !== giftCard && item.id !== insurance) {
              removeUpgrade = false;
              return;
            }
          });
    
    
          if (removeUpgrade) {
            let updates = {};
            updates[insurance] = 0
            updates[giftCard] = 0
            this.removeOrderUpgrade(updates);
          }
          if (this.querySelector('[data-upgrade-order-trigger]')) {
            this.querySelector('[data-upgrade-order-trigger]').addEventListener('click', (event) => {
      
              if (!event.target.checked) {
                let updates = {};
                updates[insurance] = 0
                updates[giftCard] = 0
                this.removeOrderUpgrade(updates);
              }
            })
          }
        }
      }

      removeOrderUpgrade(updates) {
        let body = JSON.stringify({
          updates,
          sections: this.cartDrawer.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname
        });
        
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => response.json())
          .then((parsedState) => {
            this.cartDrawer.renderContents(parsedState);
          })
          .catch((e) => {
            console.error(e);
          })
      }

      handleDiscounts() {
        let discountCode = localStorage.getItem('discounts_applied_updated');
        if (discountCode && window.storeWideDiscount) {
          document.querySelectorAll('[data-storewide-discount]').forEach((discount) => {
            let newPrice = discount.querySelector('.price__item--compare').innerHTML;
            let oldPrice = discount.querySelector('.price__item--regular').innerHTML;
            discount.querySelector('.price__item--regular').innerHTML = newPrice;
            discount.querySelector('.price__item--compare').innerHTML = oldPrice;
            discount.querySelector('.price__item--compare').classList.remove('hidden');
    
          });
          document.querySelectorAll('[data-storewide-discount-bundle]').forEach((discount) => {
            let newPrice = discount.querySelector('[data-discount-new-price]').dataset.discountNewPrice;
            discount.querySelector('[data-discount-new-price]').innerHTML = newPrice;
          });
        }
      }

      // handle product subscriptions
      handleSubscriptions() {

        // get all subscription items
        let subscriptions = this.querySelectorAll('[data-subscription-options]');

        subscriptions.forEach((subscription) => {
          let upgrade = subscription.querySelector('[data-subscription-upgrade]');
          if (upgrade) {
            upgrade.addEventListener('click', this.upgradeSubscription.bind(this));
          }
        });

        this.handlePromos();
      }

      removePromo() {
        this.cartDrawer = document.querySelector('cart-drawer');
        document.querySelectorAll('[data-promo-remove-init]').forEach((remove) => {
          remove.addEventListener('click', (event) => {
            event.preventDefault();
            this.promoWrapper.classList.remove('hidden');
            this.promoWrapper.querySelectorAll('[data-promo-remove]').forEach((button) => {
              button.addEventListener('click', (event) => {
                let itemId = remove.dataset.itemId;
                if (event.target.dataset.promoRemove == 'true') {
                  // write cookie
                  let cookie = Cookies.get('refused_promos');
                  if (typeof cookie !== 'undefined') {
                    if (cookie.length == 0) {
                      Cookies.set('refused_promos', itemId, { expires: 365 })
                    } else {
                      let newCookie = cookie + ',' + itemId;
                      Cookies.set('refused_promos', newCookie, { expires: 365 })
                    }
                  } else {
                    Cookies.set('refused_promos', itemId, { expires: 365 })
                  }
                  let updates = {};
                  updates[itemId] = 0
      
                  let body = JSON.stringify({
                    updates,
                    sections: this.cartDrawer.getSectionsToRender().map((section) => section.id),
                    sections_url: window.location.pathname
                  });
                  
                  fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
                    .then((response) => response.json())
                    .then((parsedState) => {
                      this.cartDrawer.renderContents(parsedState);
                    })
                    .catch((e) => {
                      console.error(e);
                    })
                } else {
                  this.promoWrapper.classList.add('hidden');
                }
              });
            })
          })
        });
      }

      upgradeSubscription(event) {

        let target = event.target;

        // get item selling plan
        let plan_id = target.closest('[data-subscription-options]').querySelector('select option:checked').value;
        let selling_plan = plan_id;
        if (selling_plan == 'false') {
          selling_plan = '';
        }

        // get line
        let line = target.closest('[data-subscription-options]').dataset.index;
        
        // show loaders
        this.enableLoading(line);
        let addClass = 'is-loading';
        if (selling_plan == '') {
          addClass = 'is-updating';
        }
        target.closest('[data-subscription-options]').classList.remove('has-subscription');
        target.closest('[data-subscription-options]').classList.add(addClass);

        // item quantity
        let quantity = target.closest('[data-subscription-options]').dataset.quantity;

        // create body
        let body = JSON.stringify({
          line,
          quantity,
          selling_plan,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        });
        
        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);

            this.classList.toggle('cart-is-empty', parsedState.item_count === 0);

            if (parsedState.item_count === 0) {
              Cookies.remove('refused_promos')
            }

            this.getSectionsToRender().forEach((section) => {
              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) ||
                document.getElementById(section.id);

              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );

              // Re-bind the close cart drawer buttons if cart drawer exists
              const cartDrawer = document.querySelector('cart-drawer');
              if (section.id === 'main-cart-header' && cartDrawer) {
                cartDrawer
                  .querySelectorAll('[data-cart-button-close]')
                  .forEach((btn) => btn.addEventListener('click', cartDrawer.close.bind(cartDrawer)));
              }
            });

            this.handleSubscriptions();

            // remove loaders
            target.closest('[data-subscription-options]').classList.remove(addClass);
            target.closest('[data-subscription-options]').classList.add('has-subscription');
            this.disableLoading();

            if (location.href == location.origin + '/cart' && parsedState.item_count == 0) {
              location.reload();
            }

            if (document.querySelector('cross-sell')) {
              document.querySelector('cross-sell').guardRemovals();
            }
          })
          .catch((error) => {
            console.log('error 2', error);
            document.querySelector('[data-cart-loader-active="show"]')?.classList.add('hidden');
            document.querySelector('[data-cart-loader-active="hidden"]')?.classList.remove('hidden');
            document.getElementById('cart-errors').textContent = window.cartStrings.error;
            this.disableLoading();
          });
      }

      // handle gifts
      handleGifts() {
        if (document.querySelector('[data-progressbar]')) {
          let progressbar = document.querySelector('[data-progressbar]');
          if (progressbar.dataset && progressbar.dataset.progressbar) {
            let progressbarData = JSON.parse(progressbar.dataset.progressbar);
            let free_gift = progressbarData.free_gift;
            let free_gift_variant = progressbarData.free_gift_variant;
            let free_gift_in_cart = progressbarData.free_gift_in_cart;
            let gift_mask = progressbarData.gift_mask;
            let gift_image = progressbarData.gift_image;
            let gift_title = progressbarData.gift_title;
            this.cartDrawer = document.querySelector('cart-drawer');

            let cookie = Cookies.get('refused_promos');
            let add_item = true;

            if (window.excludeFreeGift) {
              add_item = false;
            }

            if (typeof cookie !== 'undefined') {
              cookie.split(',').forEach((id) => {
                if (parseInt(id) == parseInt(free_gift_variant)) {
                  add_item = false;
                }
              });
            }

            if (free_gift) {

              // add product
              if (!free_gift_in_cart && add_item) {

                let properties = {};
                properties._promo_product = 'true';
                properties._funnel = 'cart-drawer';
                properties._funnel_location = 'progressbar';
                properties._funel_type = 'automatically added / with removal';
                properties._promo = true;
                properties._promo_discount = 100;
                properties._promo_discount_type = 'percentage';
                properties._gift_mask = gift_mask;
                properties._gift_image = gift_image;
                properties._gift_title = gift_title;
                
                let body = JSON.stringify({
                  id: free_gift_variant,
                  quantity: 1,
                  properties,
                  sections: this.cartDrawer.getSectionsToRender().map((section) => section.id),
                  sections_url: window.location.pathname
                });
                
                fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
                  .then((response) => response.json())
                  .then((parsedState) => {
                    this.cartDrawer.renderContents(parsedState);
                  })
                  .catch((e) => {
                    console.error(e);
                  })
              }
            } else {
              // remove product
              if (free_gift_in_cart) {
                let body = JSON.stringify({
                  id: free_gift_variant,
                  quantity: 0,
                  sections: this.cartDrawer.getSectionsToRender().map((section) => section.id),
                  sections_url: window.location.pathname
                });
                
                fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
                  .then((response) => response.json())
                  .then((parsedState) => {
                    this.cartDrawer.renderContents(parsedState);
                  })
                  .catch((e) => {
                    console.error(e);
                  })
              }
            }
          }
        }
      }

      // handle free samples
      handleFreeSamples() {
        if (document.querySelector('[data-free-samples]')) {
          let freeSamples = document.querySelector('[data-free-samples]');
          this.cartDrawer = document.querySelector('cart-drawer');
          let removeIds = [];
          if (freeSamples.dataset && freeSamples.dataset.freeSamples) {
            let freeSamplesData = freeSamples.dataset.freeSamples.split(',');
            let freeSamplesTotal = parseInt(freeSamples.dataset.freeSamplesTotal);
            freeSamplesData.forEach((sampleData) => {
              let sampleDataArr = sampleData.split(':');
              let sampleDataThreshold = parseInt(sampleDataArr[1]);
              if (freeSamplesTotal < sampleDataThreshold) {
                if (document.querySelector('[data-free-item-item-id="' + sampleDataArr[0] + '"]') !== null) {
                  removeIds.push(sampleDataArr[0]);
                }
              }
            });
            if (removeIds.length > 0) {
              let updates = {};
              removeIds.forEach((id) => {
                updates[id] = 0
              })

              let body = JSON.stringify({
                updates,
                sections: this.cartDrawer.getSectionsToRender().map((section) => section.id),
                sections_url: window.location.pathname
              });
              
              fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
                .then((response) => response.json())
                .then((parsedState) => {
                  this.cartDrawer.renderContents(parsedState);
                })
                .catch((e) => {
                  console.error(e);
                })
            }
          }
        }
      }

      // handle product promos
      handlePromos() {
        if (document.querySelector('[data-product-promos]')) {
          let promos = document.querySelector('[data-product-promos]');
          if (promos.dataset && promos.dataset.productPromos) {
            let promoData = JSON.parse(promos.dataset.productPromos);
            let enable_promo = promoData.promo_enabled;
    
            if (enable_promo) {
              let remove_product = promoData.remove_product;
    
              if (remove_product) {
                let lineIndex = parseFloat(document.querySelector('[data-promo-product]').dataset.index);
                this.updateQuantity(lineIndex, 0);
              }
            }
          }
        }
        this.handleGifts();
        this.handleFreeSamples();
        this.removePromo();
        this.handleProgressBar();

        if (this.querySelector('#main-cart-samples')) {
          let freeSamplesArr = this.querySelector('#main-cart-samples').querySelectorAll('.swiper-slide')
          if (freeSamplesArr.length > 0) {
            this.querySelector('#main-cart-samples').classList.remove('hidden');
          } else {
            this.querySelector('#main-cart-samples').classList.add('hidden');
          }
        }
      }

      handleProgressBar() {
        this.progressBar = document.querySelector('[data-progressbar]');
        if (this.progressBar && this.progressBar.dataset.progressbar) {
          let freeGiftVariant = JSON.parse(this.progressBar.dataset.progressbar).free_gift_variant;
          let cookie = Cookies.get('refused_promos');
          if (typeof cookie !== 'undefined') {
            cookie.split(',').forEach((cookie) => {
              if (cookie == freeGiftVariant) {
                this.progressBar.classList.add('hidden');
              }
            })
          }
        }
        let free_shipping_event = localStorage.getItem('free_shipping_event');
        if (free_shipping_event == 'true') {
          document.querySelector('.progressbar-1').classList.add('shipping');
        } else {
          document.querySelector('.progressbar-1').classList.remove('shipping');
        }
      }

      // show error texts, should not be deleted.
      updateLiveRegions(line, itemCount) {
        if (this.currentItemCount === itemCount) {
          document
            .getElementById(`Line-item-error-${line}`)
            .querySelector('.cart-item__error-text').innerHTML =
            window.cartStrings.quantityError.replace(
              '[quantity]',
              document.getElementById(`Quantity-${line}`).value
            );
        }

        this.currentItemCount = itemCount;
        this.lineItemStatusElement.setAttribute('aria-hidden', true);

        const cartStatus = document.getElementById('cart-live-region-text');
        cartStatus.setAttribute('aria-hidden', false);

        setTimeout(() => {
          cartStatus.setAttribute('aria-hidden', true);
        }, 1000);
      }

      getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
      }

      enableLoading(line) {
        document.querySelector('cart-items').classList.add('cart-items-is-loading');
        document.querySelector('[data-cart-loader-active="show"]')?.classList.remove('hidden');
        document.querySelector('[data-cart-loader-active="hidden"]')?.classList.add('hidden');
        document.activeElement.blur();
        this.lineItemStatusElement.setAttribute('aria-hidden', false);
      }

      disableLoading() {
        document.querySelector('cart-items').classList.remove('cart-items-is-loading');
      }
    }
    customElements.define('cart-items', CartItems);
  }

  /* Remove item from the cart  */
  if (!customElements.get('cart-remove-button')) {
    class CartRemoveButton extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', (event) => {
          event.preventDefault();
          this.closest('cart-items').updateQuantity(this.dataset.index, 0);
        });
      }
    }
    customElements.define('cart-remove-button', CartRemoveButton);
  }

  /* Update the cart note */
  if (!customElements.get('cart-note')) {
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, 300)
        );
      }
    }
    customElements.define('cart-note', CartNote);
  }
})();
